module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "dof-toast-wrapper weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "dof-toast-inner weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.type) ? _c('figure', {
    staticClass: "icon weex-el weex-image",
    attrs: {
      "src": _vm.icon,
      "data-img-src": _vm.icon,
      "weex-type": "image"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "dof-toast dof-toast-content weex-el weex-text",
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.content))])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34ea6d22", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ea6d22","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-toast/index.vue
// module id = 599
// module chunks = 0 1